import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
// {
//     "userId": 530,
//     "noticeTemplateId": 1,
//     "noticePath": "",
//     "uploadAt": null,
//     "noticeTemplateName": "\u6295\u4fdd\u544a\u77e5\u4e66",
//     "noticeTemplateUrl": "https:\/\/www.baidu.com",
//     "noticeTemplateRemark": "\u5e73\u5b89\u610f\u5916\u9669"
// }
import { uploadFile } from '@/views/customer/applicationManage/request';
import { getNoticeTemplateResource, backInsuranceUploadFile } from './request';
import { cryptoDecrypt } from '@/utils/aes';
import { mapState } from 'vuex';
import topTitle from '@/components/title';
export default {
  name: 'BackInsuranceUploadFile',
  components: {
    topTitle
  },
  data() {
    return {
      templateList: [],
      // 模板资源列表
      formData: {
        insuranceNotices: [] // 提交的数据
      },
      uploadAction: uploadFile,
      // 替换为实际的上传接口
      headers: {
        'X-Dispatch': 'Upload',
        'X-Version': 'upload'
      },
      loading: false
    };
  },
  computed: {
    ...mapState({
      accountInfo: state => state.user.accountInfo
    })
  },
  created() {
    this.fetchTemplateList();
  },
  methods: {
    // 获取模板列表
    async fetchTemplateList() {
      try {
        let params = {
          userId: this.accountInfo.id
        };
        const res = await getNoticeTemplateResource(params);
        console.log(res, 'fetchTemplateList');
        if (res) {
          res.forEach(item => {
            item.fileList = this.getFileList(item);
            this.templateList.push(item);
          });
          // this.templateList = JSON.parse(JSON.stringify(this.templateList));
          // // // 初始化提交数据结构
          // this.formData.insuranceNotices = this.templateList.map(item => {
          //   item.fileList = this.getFileList(item);
          //   return item;
          // });
        }
      } catch (error) {
        this.$message.error('获取模板列表失败');
      }
    },
    // 下载模板
    downloadTemplate(item) {
      if (item.noticeTemplateUrl) {
        window.open(item.noticeTemplateUrl, '_blank');
      } else {
        this.$message.warning('模板文件地址不存在');
      }
    },
    // 上传前校验
    beforeUpload(file, templateId) {
      //判断大小
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.warning(this.$t('上传文件大小不能超过50M'));
      }
      return isLt50M;
    },
    // 处理上传状态改变
    handleChange(info, item) {
      //上传不成功不展示上传的名称
      if (!info.file.status) {
        return;
      }
      if (info.file.status === 'done') {
        console.log(info.file.status, 'info.file.status');
        if (info.file.response.code != 200) {
          this.$message.error(info.file.response.message);
          item.fileList[item.fileList.length - 1].status = 'error';
        }
      }
      let fileList = info.fileList;
      item.fileList = fileList.map(file => {
        if (file.response) {
          file.url = cryptoDecrypt(file.response.data).fileTempUrl;
          // process.env.NODE_ENV === 'production'
          //   ? cryptoDecrypt(file.response.data).fileTempUrl
          //   : file.response.data.fileTempUrl;
        }
        return file;
      });
      console.log(item.fileList, 'item.fileList');
    },
    // 获取文件列表
    getFileList(item) {
      if (!item.noticePath) return [];
      return [{
        uid: `-${item.noticeTemplateId}`,
        name: `${item.noticeTemplateName}.doc`,
        // 添加默认后缀
        status: 'done',
        url: item.noticePath
      }];
    },
    // 提交表单
    async handleSubmit() {
      // 验证是否所有必需的文件都已上传
      // const unuploadedFiles = this.templateList.map(item => {
      //   const fileList = item.fileList;
      //   if (fileList.length === 0 || fileList[0].status === 'uploading') {
      //     return item.noticeTemplateName;
      //   }
      // });

      // if (unuploadedFiles.length > 0) {
      //   this.$message.warning('请上传所有必需的文件');
      //   return;
      // }
      let sumitData = this.templateList.map(item => {
        const fileList = item.fileList;
        if (fileList.length > 0 && fileList[0].status === 'done') {
          return {
            noticeTemplateId: item.noticeTemplateId,
            noticePath: fileList[0].url
          };
        }
      });
      try {
        let params = {
          insuranceNotices: sumitData
        };
        console.log(params, 'handleSubmit');
        this.loading = true;
        const res = await backInsuranceUploadFile(params);
        console.log(res, 'backInsuranceUploadFile');
        this.loading = false;
        if (res !== null && res !== void 0 && res.success) {
          this.$message.success('提交成功');
          // 刷新列表
          //   await this.fetchTemplateList();
        } else {
          this.$message.error('提交失败');
        }
      } catch (error) {
        this.loading = false;
        this.$message.error('提交失败：' + (error.message || '未知错误'));
      }
    }
  }
};